import { HostListener } from '@angular/core';
import { ScreenService } from '../_services/shared-services/screen.service';

export class BaseComponent {
    innerHeight: number;
    isXtraSmall = false;
    isSmall = false;
    isMedium = false;
    isLarge = true;

    constructor(protected readonly screenService: ScreenService) {
        this.isXtraSmall = this.screenService.isXSmallScreen();
        this.isSmall = this.screenService.isSmallScreen();
        this.isMedium = this.screenService.isMediumScreen();
        this.screenService.changed.subscribe(this.onScreenSizeChanged.bind(this));
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.innerHeight = window.innerHeight;
    }

    getMarginTopForXtraSmallDevice(value: number) {
        if (this.screenService.isXSmallScreen()) {
            return { 'margin-top': value + 'px' };
        }
        return {};
    }

    onScreenSizeChanged(): void {
        this.isXtraSmall = this.screenService.isXSmallScreen();
        this.isSmall = this.screenService.isSmallScreen();
        this.isMedium = this.screenService.isMediumScreen();
        this.isLarge = this.screenService.isLargeScreen();
    }
}
